
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upgrade",
      function () {
        return require("private-next-pages/upgrade/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upgrade"])
      });
    }
  